import { ShowroomTileBadge } from "@faire/deprecated-retailer-visitor-shared/components/Showroom/ShowroomTileBadge";
import { VolumePricingBadge } from "@faire/deprecated-retailer-visitor-shared/components/VolumePricing/VolumePricingBadge";
import { IBadge } from "@faire/web-api--source/indigofair/badges/IBadge";
import { cn } from "@faire/web/tools/cn";
import React from "react";

interface IProps {
  badge: IBadge;
  productToken?: string;
}

export const BadgeGuidepost: React.FC<IProps> = ({ badge, productToken }) => {
  if (!(badge.style?.badge_message && badge.type && badge.display_to_user)) {
    return null;
  }
  switch (badge.type) {
    case IBadge.BadgeType.SHOWROOM:
      return (
        <ShowroomTileBadge
          token={productToken}
          customEventName="product-badge"
          tooltipZIndex={1005}
        />
      );
    case IBadge.BadgeType.VOLUME_PRICING:
      return (
        <VolumePricingBadge
          discountString={badge.style.badge_message}
          className="-top-2"
        />
      );

    default:
      return (
        <Badge className="cursor-pointer" content={badge.style.badge_message} />
      );
  }
};

const Badge: React.FC<{ className: string; content: string }> = ({
  className,
  content,
}) => {
  return (
    <div
      className={cn(
        className,
        "flex flex-row items-center justify-center",
        "font-fs-label font-medium",
        "truncate",
        "min-h-[22px] w-fit max-w-full min-w-[20px]",
        "px-[7px] py-[3px]",
        "rounded-[4px]",
        "border-core-surface-inverse border border-solid",
        "bg-core-surface-inverse",
        "text-core-text-default"
      )}
    >
      {content}
    </div>
  );
};
